import { Badge } from 'react-bootstrap';
import { createStyles, makeStyles } from '@material-ui/core';
import themes from 'styles/themes';

interface Iprops {
    label: {
        name?: string;
        icon?: any;
        background?: string;
    };
}

export const useStyles = makeStyles(() =>
    createStyles({
        labelBadge: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '15px',
            color: themes.palette.primary.main,
            fontSize: '12px',
            fontWeight: 500,
            padding: '6px 8px',
            marginTop: 5,
        },
        icon: {
            maxWidth: '40px',
            height: 'auto',
            maxHeight: 14,
            marginRight: 3,
        },
        text: {
            margin: 0,
        },
    }),
);

const StandardLabelTag = ({ label }: Iprops) => {
    const classes = useStyles();
    return (
        <Badge
            className={classes.labelBadge}
            style={{ backgroundColor: label?.background ? label?.background : '#FFE68E' }}
        >
            {label?.icon && <img src={label.icon} alt="" className={classes.icon} />}
            {label?.name && <p className={classes.text}>{label.name}</p>}
        </Badge>
    );
};

export default StandardLabelTag;
